// polyfils
import './polyfills/classList.js';
import './polyfills/customEvent.js';
import './polyfills/closest.js';
import './polyfills/object-assign.js';
import './polyfills/array-from.js';


import KB from '@switch-company/keyboard-navigation';

new KB();

import './helpers/expand-toggle';

// Libs
import './modules/cookie';
import './modules/nav';
import scrollTo from './helpers/scrollTo';
import { mq } from "./helpers/css.json";

if( typeof CSS == 'undefined' || ( CSS && !CSS.supports ) || ( CSS.supports && !CSS.supports( 'object-fit', 'cover' ))){
  [].slice.call( document.querySelectorAll( '.ofit' )).forEach(( elt ) => {

    const parent = elt.parentNode.tagName.toLowerCase() !== 'picture' ? elt.parentNode : elt.parentNode.parentNode;

    parent.classList.add( 'object-fit' );
    parent.style.backgroundImage = `url(${elt.src})`;

  });
}
$(document).ready(function() {

  $(window).on('load', function(){

    $('body')
      .on('mousemove', function () {
        $('html').addClass('is-mouse').removeClass('is-touch');
      })
      .on('touchend', function () {
        setTimeout(function () {
          $('html').addClass('is-touch').removeClass('is-mouse');
        },1);
      });

    // Accordions
    $('.js-has-accordions-list').each(function () {
      $(this).find('.accordion--trigger').on('click', function () {
        $(this).closest('li').siblings('li').find('.accordion--trigger').removeClass('is-expanded').siblings('.accordion--dropdown').stop().slideUp('fast');
        $(this).toggleClass('is-expanded').siblings('.accordion--dropdown').stop().slideToggle('fast');
      });
    });

    // SLIDERS
    $('.slider').flickity({
      prevNextButtons: false,
      groupCells: true,
      // if set to true,
      // group cells that fit in carousel viewport
      dragThreshold: 10,
      // dragging doesn't start until 10px moved
      // more room for vertical scrolling
      // on touch devices
    });

    // SUMMARY ( do it before lettering to get text without span)
    var $editoTitles = $('.edito--subcover--title');
    $editoTitles.each(function (index, title) {
      var label = $(this).find('h2').html().replace('²', '');
      $(this).closest('.edito--subcover').attr('id', 'edito-hash-'+index);
      $('.edito--summary ol').append('<li><a class="js-scroll-to-hash" href="#edito-hash-' + index + '">' + label + '</a></li>');
      var $trigger = $('<li>', {
        html: '<a class="js-scroll-to-hash" href="#edito-hash-' + index + '" title="' + label + '"></a></li>'
      });
      $(this).data('$trigger', $trigger);
      $('.edito--scroll-nav ul').append($trigger);

    });
    if($('.edito--scroll-nav').length) {
      var $scrollNav = $('.edito--scroll-nav--wrapper');
      var $scrollNavAbsolute = $('<div>', {
        class: 'edito--scroll-nav--wrapper absolute-pos'
      }).append($scrollNav.children('.edito--scroll-nav'));
      var $scrollNavProgress = $scrollNavAbsolute.find('.edito--scroll-nav--progress');
      var $sectionToScroll = $scrollNav.parent('div');
      $scrollNav.after($scrollNavAbsolute);
      $(window).on('scroll.scroll-nav', function () {
        placePager();
      });

      var collision = function($div1, $div2) {
        var x1 = $div1.offset().left;
        var y1 = $div1.offset().top;
        var h1 = $div1.outerHeight(true);
        var w1 = $div1.outerWidth(true);
        var b1 = y1 + h1;
        var r1 = x1 + w1;
        var x2 = $div2.offset().left;
        var y2 = $div2.offset().top;
        var h2 = $div2.outerHeight(true);
        var w2 = $div2.outerWidth(true);
        var b2 = y2 + h2;
        var r2 = x2 + w2;

        if (b1 < y2 || y1 > b2 || r1 < x2 || x1 > r2) return false;
        return true;
      };

      var placePager = function(){
        var scrollTop = $(window).scrollTop();
        var sectionTop = $sectionToScroll.offset().top;
        var deltaTop = $scrollNav.offset().top - sectionTop;
        var sectionH = $sectionToScroll.height() - deltaTop ;

        var height = Math.max(0, Math.min(100, (scrollTop - sectionTop - deltaTop) / (sectionH - $(window).height()) * 100 + 1) );

        $scrollNavProgress.css({
          height: height + '%'
        });

        $editoTitles.each(function(){
          var pos = ($(this).closest('.edito--subcover').offset().top - sectionTop - deltaTop) / (sectionH - $(window).height()) * 100;
          var $trigger = $(this).data('$trigger');
          $trigger.css({top: Math.min(100, pos) + '%'});
          if(collision($trigger.children('a'), $scrollNavProgress)) {
            $trigger.addClass('is-active');
          } else {
            $trigger.removeClass('is-active').next('li').removeClass('is-active');
          }
        });
      };

      $(window).on('resize.scroll-nav', function () {
        $(window).trigger('scroll.scroll-nav');
        $scrollNavAbsolute.data('top', $scrollNav.offset().top - $('.nav-wrapper').height() + 10 );
      });
      $(window).trigger('resize.scroll-nav');

      $scrollNavAbsolute.find('.edito--scroll-nav').css({
        top: $scrollNavAbsolute.data('top')
      });
      $scrollNavAbsolute.find('.edito--scroll-nav').stick_in_parent({
        offset_top: $('.nav-wrapper').height() + 30
      })
        .on('sticky_kit:unstick', function(e) {
          // console.log('has stuck!', e.target);
          $scrollNavAbsolute.find('.edito--scroll-nav').css({
            top: $scrollNavAbsolute.data('top')
          });
        });
      var $scrollNavSection = $scrollNav.parent();
    }

    $('.nav-edito ul').each(function () {
      var $container = $(this);
      var containerLeft = $container.offset().left;
      if($container.find('.is-active').length) {
        var activeLeft = $container.find('.is-active').offset().left;
        $container.scrollLeft(activeLeft - containerLeft);
      }
    });

    $('.manifesto--background').stick_in_parent();

    // INIT ELEMENT TO ANIMATE
    $('.title-main,' +
      ' .title-second,' +
      ' .edito--title h2.edito--title--title,' +
      ' .page-edito.edito .content-wrapper > .wysiwyg > h2,' +
      ' .page-edito.edito-long-read .content-wrapper > .wysiwyg > h3,' +
      ' .page-edito.page-verger .content-wrapper > .wysiwyg > h3'
    ).addClass('has-title-second-display');
    $('.manifesto--content > p,' +
      ' .manifesto--content--cta,' +
      ' .game--intro--content p,' +
      ' .game--intro--media,' +
      ' .accordions--list--item,' +
      ' .highlight-block,' +
      ' .edito--summary li,' +
      ' .page-edito.edito .content-wrapper > .wysiwyg > p,' +
      ' .page-edito.edito-long-read .content-wrapper > .wysiwyg > p,' +
      ' .page-edito.page-verger .content-wrapper > .wysiwyg > p,' +
      ' .sources--wrapper,' +
      ' .edito--cta'
    ).addClass('has-text-display' );

    // ANIMATED Scroll to hash
    $('body').on('click', 'a.js-scroll-to-hash', function (event) {
      event.stopPropagation();
      event.preventDefault();
      event.preventDefault();
      scrollTo( $($(this).attr('href')).offset().top - ($(this).attr('href') == '#to-up' ? 0 : $('.nav-wrapper').height() ), 500 );
    });

    // LETTERING
    $('.edito--cover--title,' +
      '.edito--title h2.edito--title--title,' +
      '.page-edito.edito .content-wrapper > .wysiwyg > h2,' +
      '.page-edito.edito-long-read .content-wrapper > .wysiwyg > h3,' +
      '.page-edito.page-verger .content-wrapper > .wysiwyg > h3,' +
      '.title-main,' +
      '.title-second')
      .lettering('words')
      .addClass('visible').each(function () {
        $(this).html($(this).html().replace('®', '<sup>®</sup>').replace('²', '<sup>2</sup>'))
    });

    // ANIMATION INTRO
    var matches = document.querySelectorAll('.edito--cover--title span');

    $('.edito--cover--logo').addClass('visible');
    setTimeout(function(){
      anime({
        targets: matches ,
        translateY: -20,
        opacity:1,
        delay: anime.stagger(100),
        easing: 'spring(1, 80, 10, 0)'
      });

    },200);

    // ANIMATION TITLES
    var titlesContainers = [
      $( '.manifesto--content' ),
      $( '.edito--summary' ),
      $( '.edito--title' ),
      $( '.wysiwyg--wrapper' ),
      $( '.game--intro--content' ),
      $( '.edito--subcover' )];
    $.each(titlesContainers, function(){
      var $container = $(this);
      $container.each(function( index ) {
        window['waypointTitle' + index ] = new Waypoint({
          element: $(this)[0],
          handler: function(direction ) {
            var container = $container.get(index);
            var matches = container.querySelectorAll('.has-title-second-display span');
            if(direction != 'up') {
              anime({
                targets: matches ,
                translateY: -10,
                opacity:1,
                delay: anime.stagger(100)
              });
            } else {
              anime({
                targets: matches ,
                translateY: 0,
                opacity:0,
                delay: anime.stagger(100)
              });
            }
          },
          offset:'85%'
        });
      });
    });
    // ANIMATION TEXTS
    $( '.has-text-display' ).each(function( index ) {
      window['waypointTexts' + index ] = new Waypoint({
        element: $(this)[0],
        handler: function(direction ) {
          if(direction != 'up') {
            $(this.element).addClass('visible');
          } else {
            $(this.element).removeClass('visible');
          }
        },
        offset:'95%'
      });
    });

    // GRID MEDIA
    $('.grid-medias--list').masonry({
      itemSelector: '.grid-medias--item',
      percentPosition: true,
      gutter: 0,
      horizontalOrder: false,
    });
    $('.grid-medias--list').each(function(){
      $(this).magnificPopup({
        tClose: 'Fermer (Esc)',
        tLoading: 'Chargement...',
        image: {
          tError: '<a href="%url%">l\' image</a> n\'a pas pu être chargée.'
        },
        ajax: {
          tError: '<a href="%url%">La requête</a> a échoué.'
        },
        delegate: 'a', // child items selector, by clicking on it popup will open
        type: 'image',
        // other options
        gallery:{
          tPrev: 'Précédente',
          tNext: 'Suivante',
          tCounter: '%curr% sur %total%',
          enabled:true
        },
        mainClass: 'mfp-with-zoom', // this class is for CSS animation below
        zoom: {
          enabled: true, // By default it's false, so don't forget to enable it
        },
      });
    });

    // Motions Verger
    $('.edito--text-and-motion--motion-design--svg').each(function (index) {
      const animationId = $(this).attr('id');
      //console.log('animationId : ', animationId);

      const animationData = animationMotion[animationId.replace('motion-', '')];
      //console.log('animationData : ', animationData);
      const params = {
        container: document.getElementById(animationId),
        renderer: 'svg',
        loop: true,
        autoplay: false,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: (animationId === 'motion-bees' || animationId === 'motion-weather' ? 'xMinYMid' : 'xMidYMid' )+ ' meet'
        }
      };
      const animation = lottie.loadAnimation(params);

      //animation.play();
      const inview = new Waypoint.Inview({
        element: this,
        enter: function(direction) {
          animation.play();
        },
        exited: function(direction) {
          animation.stop();
        }
      });
    });

    // Interview
    $('.interviews').each(function (index) {
      const $interviewsContainer = $(this);
      const $interviews = $(this).find('.interview');

      // clone triggers
      $interviews.each(function () {
        const $trigger = $(this).find('.interview--trigger');
        const $triggerCloned = $trigger.clone();
        $trigger.data('trigger', $triggerCloned);
        $triggerCloned.data('trigger', $trigger);
        $(this).closest('.interviews').find('.interviews--tabs').append($triggerCloned);
      });

      $interviewsContainer.on('click', '.interview--trigger', function () {
        let isVisible = false;
        const $trigger = $(this);
        if($trigger.hasClass('is-visible')) {
          isVisible = true;
        }
        $trigger.closest('.interviews').find('.is-visible').removeClass('is-visible');

        if(!isVisible) {
          $trigger.addClass('is-visible').closest('.interviews--item').addClass('is-visible');
          $trigger.data('trigger').addClass('is-visible').closest('.interviews--item').addClass('is-visible');
        }

        scrollTo( ($trigger.closest('.interviews--tabs').length ? $trigger.closest('.interviews--tabs').offset().top : $trigger.offset().top) - $('.nav-wrapper').height() - 20, 0 );
      });

    });


    $(window).on('resize.interviews', function () {
      console.log('resize.interviews');
      // test on resize if desktop to display first item if no accordion opened
      if( window.matchMedia( mq.w1024 ).matches ){
        $('.interviews').each(function (index) {
          const $interviewsContainer = $(this);
          const $interviews = $(this).find('.interview');
          if(!$interviewsContainer.find('.interviews--item.is-visible').length) {
            $interviewsContainer.find('.interviews--item').eq(0).addClass('is-visible');
            $interviewsContainer.find('.interview--trigger').eq(0).addClass('is-visible');
          }
        });
      }
    });
    $(window).trigger('resize.interviews');

    // PARALLAX
    var rellax = new Rellax('.rellax', {
      center: true
    });

    $(window).trigger('resize'); // fix
  });

  $(document).ready(function () {
    // Illustration strate
    $('.pointer').on('click', function () {
      var editoPopin = $('.edito--picture-popin-wrapper');
      var editoLayer = $('.edito--picture-popin-layer');
      editoPopin.addClass('popin-displayed');
      editoLayer.addClass('layer-displayed');
      $(document.body).addClass('no-scroll');

      if ( $(this).hasClass('pointer-1') ){
        $('.edito--picture-popin').removeClass('content-displayed');
        $('.edito--picture-popin-one').addClass('content-displayed');
        $('.pagination--btn-prev').addClass('btn-unable');
        $('.pagination--btn-next').removeClass('btn-unable');
      }
      if ( $(this).hasClass('pointer-2') ){
        $('.edito--picture-popin').removeClass('content-displayed');
        $('.edito--picture-popin-two').addClass('content-displayed');
        $('.pagination--btn-prev').removeClass('btn-unable');
        $('.pagination--btn-next').removeClass('btn-unable');
      }
      if ( $(this).hasClass('pointer-3') ){
        $('.edito--picture-popin').removeClass('content-displayed');
        $('.edito--picture-popin-three').addClass('content-displayed');
        $('.pagination--btn-prev').removeClass('btn-unable');
        $('.pagination--btn-next').removeClass('btn-unable');
      }
      if ( $(this).hasClass('pointer-4') ){
        $('.edito--picture-popin').removeClass('content-displayed');
        $('.edito--picture-popin-four').addClass('content-displayed');
        $('.pagination--btn-prev').removeClass('btn-unable');
        $('.pagination--btn-next').removeClass('btn-unable');
      }
      if ( $(this).hasClass('pointer-5') ){
        $('.edito--picture-popin').removeClass('content-displayed');
        $('.edito--picture-popin-five').addClass('content-displayed');
        $('.pagination--btn-next').addClass('btn-unable');
      }
    });

    $('.pagination--btn-prev').on('click', function(){
      if ( $('.edito--picture-popin-two').hasClass('content-displayed') ){
        $('.edito--picture-popin').removeClass('content-displayed');
        $('.edito--picture-popin-one').addClass('content-displayed');
        $('.pagination--btn-prev').addClass('btn-unable');
      }
      else if ( $('.edito--picture-popin-three').hasClass('content-displayed') ){
        $('.edito--picture-popin').removeClass('content-displayed');
        $('.edito--picture-popin-two').addClass('content-displayed');
        $('.pagination--btn-prev').removeClass('btn-unable');
      }
      else if ( $('.edito--picture-popin-four').hasClass('content-displayed') ){
        $('.edito--picture-popin').removeClass('content-displayed');
        $('.edito--picture-popin-three').addClass('content-displayed');
        $('.pagination--btn-prev').removeClass('btn-unable');
      }
      else if ( $('.edito--picture-popin-five').hasClass('content-displayed') ){
        $('.edito--picture-popin').removeClass('content-displayed');
        $('.edito--picture-popin-four').addClass('content-displayed');
        $('.pagination--btn-prev').removeClass('btn-unable');
        $('.pagination--btn-next').removeClass('btn-unable');
      }
    });

    $('.pagination--btn-next').on('click', function(){
      if ( $('.edito--picture-popin-one').hasClass('content-displayed') ){
        $('.edito--picture-popin').removeClass('content-displayed');
        $('.edito--picture-popin-two').addClass('content-displayed');
        $('.pagination--btn-prev').removeClass('btn-unable');
        $('.pagination--btn-next').removeClass('btn-unable');
      }
      else if ( $('.edito--picture-popin-two').hasClass('content-displayed') ){
        $('.edito--picture-popin').removeClass('content-displayed');
        $('.edito--picture-popin-three').addClass('content-displayed');
        $('.pagination--btn-next').removeClass('btn-unable');
      }
      else if ( $('.edito--picture-popin-three').hasClass('content-displayed') ){
        $('.edito--picture-popin').removeClass('content-displayed');
        $('.edito--picture-popin-four').addClass('content-displayed');
        $('.pagination--btn-next').removeClass('btn-unable');
      }
      else if ( $('.edito--picture-popin-four').hasClass('content-displayed') ){
        $('.edito--picture-popin').removeClass('content-displayed');
        $('.edito--picture-popin-five').addClass('content-displayed');
        $('.pagination--btn-next').addClass('btn-unable');
      }
    });

    $('.pagination--btn-close').on('click', function(){
      var editoPopin = $('.edito--picture-popin-wrapper');
      var editoLayer = $('.edito--picture-popin-layer');
      editoPopin.removeClass('popin-displayed');
      editoLayer.removeClass('layer-displayed');
      $(document.body).removeClass('no-scroll');
    });

    $('.edito--picture-popin-layer').on('click', function(){
      var editoPopin = $('.edito--picture-popin-wrapper');
      var editoLayer = $('.edito--picture-popin-layer');
      editoPopin.removeClass('popin-displayed');
      editoLayer.removeClass('layer-displayed');
      $(document.body).removeClass('no-scroll');
    });

    // Timeline slider - Next / Prev buttons
    var timelineBtnPrev = $('.timeline-pagination--btn-prev');
    var timelineBtnNext = $('.timeline-pagination--btn-next');

    timelineBtnNext.on('click', function(){
      if ( $('.timeline-displayed').hasClass('timeline-slide1') ){
        $('.timeline-slide1').removeClass('timeline-displayed');
        $('.timeline-slide2').addClass('timeline-displayed');
        $('.goto--slide1').removeClass('timeline-slider--slide-displayed');
        $('.goto--slide2').addClass('timeline-slider--slide-displayed');
        timelineBtnPrev.removeClass('btn-unable');
        $('.goto--slide1').removeClass('btn-invisible');
        $('.goto--slide2').removeClass('btn-invisible');
        $('.goto--slide3').removeClass('btn-invisible');
        $('.goto--slide4').addClass('btn-invisible');
        $('.goto--slide5').addClass('btn-invisible');
        $('.goto--slide6').addClass('btn-invisible');
      }
      else if ( $('.timeline-displayed').hasClass('timeline-slide2') ){
        $('.timeline-slide2').removeClass('timeline-displayed');
        $('.timeline-slide3').addClass('timeline-displayed');
        $('.goto--slide2').removeClass('timeline-slider--slide-displayed');
        $('.goto--slide3').addClass('timeline-slider--slide-displayed');
        $('.goto--slide1').addClass('btn-invisible');
        $('.goto--slide2').removeClass('btn-invisible');
        $('.goto--slide3').removeClass('btn-invisible');
        $('.goto--slide4').removeClass('btn-invisible');
        $('.goto--slide5').addClass('btn-invisible');
        $('.goto--slide6').addClass('btn-invisible');
      }
      else if ( $('.timeline-displayed').hasClass('timeline-slide3') ){
        $('.timeline-slide3').removeClass('timeline-displayed');
        $('.timeline-slide4').addClass('timeline-displayed');
        $('.goto--slide3').removeClass('timeline-slider--slide-displayed');
        $('.goto--slide4').addClass('timeline-slider--slide-displayed');
        $('.goto--slide1').addClass('btn-invisible');
        $('.goto--slide2').addClass('btn-invisible');
        $('.goto--slide3').removeClass('btn-invisible');
        $('.goto--slide4').removeClass('btn-invisible');
        $('.goto--slide5').removeClass('btn-invisible');
        $('.goto--slide6').addClass('btn-invisible');
      }
      else if ( $('.timeline-displayed').hasClass('timeline-slide4') ){
        $('.timeline-slide4').removeClass('timeline-displayed');
        $('.timeline-slide5').addClass('timeline-displayed');
        $('.goto--slide4').removeClass('timeline-slider--slide-displayed');
        $('.goto--slide5').addClass('timeline-slider--slide-displayed');
        $('.goto--slide1').addClass('btn-invisible');
        $('.goto--slide2').addClass('btn-invisible');
        $('.goto--slide3').removeClass('btn-invisible');
        $('.goto--slide4').removeClass('btn-invisible');
        $('.goto--slide5').removeClass('btn-invisible');
        timelineBtnNext.addClass('btn-unable');
      }
    });

    timelineBtnPrev.on('click', function(){
      if ( $('.timeline-displayed').hasClass('timeline-slide5') ){
        $('.timeline-slide5').removeClass('timeline-displayed');
        $('.timeline-slide4').addClass('timeline-displayed');
        $('.goto--slide5').removeClass('timeline-slider--slide-displayed');
        $('.goto--slide4').addClass('timeline-slider--slide-displayed');
        $('.goto--slide1').addClass('btn-invisible');
        $('.goto--slide2').addClass('btn-invisible');
        $('.goto--slide3').removeClass('btn-invisible');
        $('.goto--slide4').removeClass('btn-invisible');
        $('.goto--slide5').removeClass('btn-invisible');
        timelineBtnNext.removeClass('btn-unable');
      }
      else if ( $('.timeline-displayed').hasClass('timeline-slide4') ){
        $('.timeline-slide4').removeClass('timeline-displayed');
        $('.timeline-slide3').addClass('timeline-displayed');
        $('.goto--slide4').removeClass('timeline-slider--slide-displayed');
        $('.goto--slide3').addClass('timeline-slider--slide-displayed');
        $('.goto--slide1').addClass('btn-invisible');
        $('.goto--slide2').removeClass('btn-invisible');
        $('.goto--slide3').removeClass('btn-invisible');
        $('.goto--slide4').removeClass('btn-invisible');
        $('.goto--slide5').addClass('btn-invisible');
        $('.goto--slide6').addClass('btn-invisible');
      }
      else if ( $('.timeline-displayed').hasClass('timeline-slide3') ){
        $('.timeline-slide3').removeClass('timeline-displayed');
        $('.timeline-slide2').addClass('timeline-displayed');
        $('.goto--slide3').removeClass('timeline-slider--slide-displayed');
        $('.goto--slide2').addClass('timeline-slider--slide-displayed');
        $('.goto--slide1').removeClass('btn-invisible');
        $('.goto--slide2').removeClass('btn-invisible');
        $('.goto--slide3').removeClass('btn-invisible');
        $('.goto--slide4').addClass('btn-invisible');
        $('.goto--slide5').addClass('btn-invisible');
        $('.goto--slide6').addClass('btn-invisible');
      }
      else if ( $('.timeline-displayed').hasClass('timeline-slide2') ){
        $('.timeline-slide2').removeClass('timeline-displayed');
        $('.timeline-slide1').addClass('timeline-displayed');
        $('.goto--slide2').removeClass('timeline-slider--slide-displayed');
        $('.goto--slide1').addClass('timeline-slider--slide-displayed');
        $('.goto--slide1').removeClass('btn-invisible');
        $('.goto--slide2').removeClass('btn-invisible');
        $('.goto--slide3').removeClass('btn-invisible');
        $('.goto--slide4').addClass('btn-invisible');
        $('.goto--slide5').addClass('btn-invisible');
        $('.goto--slide6').addClass('btn-invisible');
        timelineBtnPrev.addClass('btn-unable');
      }
    });

    // Timeline slider - Pagination buttons
    var paginationBtn = $('.timeline-pagination--btn-slide');

    $('.goto--slide4').addClass('btn-invisible');
    $('.goto--slide5').addClass('btn-invisible');

    paginationBtn.on('click', function(){
      if ($(this).hasClass('btn-goto--slide1')){
        $('.timeline-slider--slide').removeClass('timeline-displayed');
        $('.timeline-slide1').addClass('timeline-displayed');
        $('.timeline-slider--slide-btn-wrapper').removeClass('timeline-slider--slide-displayed');
        $('.goto--slide1').addClass('timeline-slider--slide-displayed');
        $('.goto--slide1').removeClass('btn-invisible');
        $('.goto--slide2').removeClass('btn-invisible');
        $('.goto--slide3').removeClass('btn-invisible');
        $('.goto--slide4').addClass('btn-invisible');
        $('.goto--slide5').addClass('btn-invisible');
        timelineBtnPrev.addClass('btn-unable');
        timelineBtnNext.removeClass('btn-unable');
      }
      if ($(this).hasClass('btn-goto--slide2')){
        $('.timeline-slider--slide').removeClass('timeline-displayed');
        $('.timeline-slide2').addClass('timeline-displayed');
        $('.timeline-slider--slide-btn-wrapper').removeClass('timeline-slider--slide-displayed');
        $('.goto--slide2').addClass('timeline-slider--slide-displayed');
        $('.goto--slide1').removeClass('btn-invisible');
        $('.goto--slide2').removeClass('btn-invisible');
        $('.goto--slide3').removeClass('btn-invisible');
        $('.goto--slide4').addClass('btn-invisible');
        $('.goto--slide5').addClass('btn-invisible');
        $('.goto--slide6').addClass('btn-invisible');
        timelineBtnPrev.removeClass('btn-unable');
        timelineBtnNext.removeClass('btn-unable');
      }
      if ($(this).hasClass('btn-goto--slide3')){
        $('.timeline-slider--slide').removeClass('timeline-displayed');
        $('.timeline-slide3').addClass('timeline-displayed');
        $('.timeline-slider--slide-btn-wrapper').removeClass('timeline-slider--slide-displayed');
        $('.goto--slide3').addClass('timeline-slider--slide-displayed');
        $('.goto--slide1').addClass('btn-invisible');
        $('.goto--slide2').removeClass('btn-invisible');
        $('.goto--slide3').removeClass('btn-invisible');
        $('.goto--slide4').removeClass('btn-invisible');
        $('.goto--slide5').addClass('btn-invisible');
        $('.goto--slide6').addClass('btn-invisible');
        timelineBtnPrev.removeClass('btn-unable');
        timelineBtnNext.removeClass('btn-unable');
      }
      if ($(this).hasClass('btn-goto--slide4')){
        $('.timeline-slider--slide').removeClass('timeline-displayed');
        $('.timeline-slide4').addClass('timeline-displayed');
        $('.timeline-slider--slide-btn-wrapper').removeClass('timeline-slider--slide-displayed');
        $('.goto--slide4').addClass('timeline-slider--slide-displayed');
        $('.goto--slide1').addClass('btn-invisible');
        $('.goto--slide2').addClass('btn-invisible');
        $('.goto--slide3').removeClass('btn-invisible');
        $('.goto--slide4').removeClass('btn-invisible');
        $('.goto--slide5').removeClass('btn-invisible');
        $('.goto--slide6').addClass('btn-invisible');
        timelineBtnPrev.removeClass('btn-unable');
        timelineBtnNext.removeClass('btn-unable');
      }
      if ($(this).hasClass('btn-goto--slide5')){
        $('.timeline-slider--slide').removeClass('timeline-displayed');
        $('.timeline-slide5').addClass('timeline-displayed');
        $('.timeline-slider--slide-btn-wrapper').removeClass('timeline-slider--slide-displayed');
        $('.goto--slide5').addClass('timeline-slider--slide-displayed');
        $('.goto--slide1').addClass('btn-invisible');
        $('.goto--slide2').addClass('btn-invisible');
        $('.goto--slide3').removeClass('btn-invisible');
        $('.goto--slide4').removeClass('btn-invisible');
        $('.goto--slide5').removeClass('btn-invisible');
        timelineBtnPrev.removeClass('btn-unable');
        timelineBtnNext.addClass('btn-unable');
      }

    });

  });

});
